var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add an Item"},on:{"on-hide":_vm.resetFormData}},[_c('technician-payment-item-form',{key:_vm.formKey,on:{"on-submit":_vm.createItem,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }